/** Sent on authenticated requests so the backend knows which profile is active. */
export const SELECTED_USER_HEADER = 'X-Request-ID';

/** Persisted as `{ ownerUserId, selectedUserId }` so a new login cannot reuse another user's choice. */
export const SELECTED_USER_STORAGE_KEY = 'aliro_selected_user_id';
